var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn",
    clipPath: "url(#clip0_845_1726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.8333 0H7.16667C3.48533 0 0.5 2.98533 0.5 6.66667V25.3333C0.5 29.0147 3.48533 32 7.16667 32H25.8333C29.516 32 32.5 29.0147 32.5 25.3333V6.66667C32.5 2.98533 29.516 0 25.8333 0ZM11.1667 25.3333H7.16667V10.6667H11.1667V25.3333ZM9.16667 8.976C7.87867 8.976 6.83333 7.92267 6.83333 6.624C6.83333 5.32533 7.87867 4.272 9.16667 4.272C10.4547 4.272 11.5 5.32533 11.5 6.624C11.5 7.92267 10.456 8.976 9.16667 8.976ZM27.1667 25.3333H23.1667V17.8613C23.1667 13.3707 17.8333 13.7107 17.8333 17.8613V25.3333H13.8333V10.6667H17.8333V13.02C19.6947 9.572 27.1667 9.31733 27.1667 16.3213V25.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_1726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.2c2c58b6742da9d2abaa9e01c1fa52fe.svg";
export { ForwardRef as ReactComponent };